import React from 'react';
import { useQuery } from '@apollo/client';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { SubscriptionTab } from '@css-xp/base/common-tabs';
import { fetchSubscriptionsForPaymentMethod } from './queries/fetch-subscriptions-for-payment-method';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';

interface SubscriptionTabPaymentMethodProps {
  paymentMethodId?: string;
  label?: string;
  availableInvoiceGroups?: generatedTypesNew.Maybe<generatedTypesNew.InvoiceGroup[]>;
}

export const SubscriptionTableForPaymentMethod = ({
  paymentMethodId,
  label,
  availableInvoiceGroups,
}: SubscriptionTabPaymentMethodProps) => {
  const { data, loading, error, refetch } = useQuery<
    generatedTypesNew.FetchSubscriptionsForPaymentMethodQuery,
    generatedTypesNew.FetchSubscriptionsForPaymentMethodQueryVariables
  >(fetchSubscriptionsForPaymentMethod, {
    variables: {
      id: paymentMethodId ?? '',
      searchOptions: { first: DEFAULT_ROWS_PER_PAGE },
    },
    skip: !paymentMethodId,
    nextFetchPolicy: 'cache-and-network',
  });

  const nodes = data?.invoiceGroupsForPaymentMethod?.productSubscriptions?.nodes;
  const totalCount = data?.invoiceGroupsForPaymentMethod?.productSubscriptions?.totalCount ?? 0;

  return (
    <SubscriptionTab
      nodes={nodes}
      totalRecords={totalCount}
      loading={loading}
      error={error}
      refetch={refetch}
      label={label}
      isPaymentMethodSidebar={true}
      availableInvoiceGroups={availableInvoiceGroups}
    />
  );
};
